module.exports = __webpack_public_path__ + "static/media/news5.62be120e.png";